import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiData, PureBiData } from '@wix/da-bi/pkg/events';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import StandardMenu from '../../../../Dropdown/MenuPreset/StandardMenu';
import { getDeviationResourceType } from '../../../../DeviationViews/_helpers';
import { useVerification } from '../../../../VerificationPopup/withVerification';
import { ElementVisibilityContext, ElementVisibility } from '../../../ElementVisibilityContext';
import { useFreeDownloadAction, usePremiumDownloadAction } from '../../DownloadButton/hooks';
import s from './MoreMenuContent.scss';
// This is used only on desktop
const MoreMenuContent = ({ deviation , isOwner , closeTooltip =()=>null , showReportModal , showDesktopDeviationSharePopup , showNftLinkPopup , shareDeviationToPost , showAddToGroupPopup , showAwardBadgePopup , onToggleCommentPanel  })=>{
    var _deviation_author;
    const { t  } = useTranslation();
    const { restrictToVerifiedAndLoggedIn  } = useVerification();
    const elementVisibilityMap = useContext(ElementVisibilityContext);
    const freeDownloadAction = useFreeDownloadAction(deviation, isOwner);
    const premiumDownloadAction = usePremiumDownloadAction(deviation, isOwner);
    var _deviation_author_useridUuid;
    return /*#__PURE__*/ React.createElement(StandardMenu, {
        className: s['menu'],
        id: "actionbar-more-menu",
        items: [
            elementVisibilityMap.comment === ElementVisibility.Menu && {
                value: 'comment',
                label: t('actionbar.comment.label'),
                onClick: onToggleCommentPanel,
                biData: BiData({
                    evid: 105,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    creatorid: (_deviation_author_useridUuid = (_deviation_author = deviation.author) === null || _deviation_author === void 0 ? void 0 : _deviation_author.useridUuid) !== null && _deviation_author_useridUuid !== void 0 ? _deviation_author_useridUuid : ''
                })
            },
            elementVisibilityMap.premiumDownload === ElementVisibility.Menu && premiumDownloadAction.hasAction && {
                value: 'download',
                label: t('actionbar.premiumDownload'),
                link: premiumDownloadAction.href,
                onClick: ()=>{
                    premiumDownloadAction.onClick && premiumDownloadAction.onClick();
                    closeTooltip();
                },
                biData: PureBiData({
                    evid: 350,
                    ispaiddownload: 1,
                    deviationid: deviation.deviationId,
                    sectionname: 'action_bar'
                })
            },
            elementVisibilityMap.freeDownload === ElementVisibility.Menu && freeDownloadAction.hasAction && {
                value: 'download',
                label: t('actionbar.freeDownload'),
                link: freeDownloadAction.href,
                onClick: ()=>{
                    freeDownloadAction.onClick && freeDownloadAction.onClick();
                    closeTooltip();
                },
                biData: PureBiData({
                    evid: 350,
                    ispaiddownload: 0,
                    deviationid: deviation.deviationId,
                    sectionname: 'action_bar'
                })
            },
            elementVisibilityMap.addToGroup === ElementVisibility.Menu && {
                value: 'addToGroup',
                label: t('actionbar.addToGroup'),
                onClick: ()=>{
                    showAddToGroupPopup();
                    closeTooltip();
                },
                biData: BiData({
                    evid: 340,
                    deviationid: deviation.deviationId,
                    sectionname: 'add_to_group'
                })
            },
            elementVisibilityMap.awardBadge === ElementVisibility.Menu && {
                value: 'awardBadge',
                label: t('actionbar.awardBadge'),
                onClick: ()=>{
                    showAwardBadgePopup(deviation);
                    closeTooltip();
                },
                biData: {
                    evid: BiEventType.GIVE_BADGE_AWARD,
                    sectionname: 'deviation',
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId
                }
            },
            elementVisibilityMap.share === ElementVisibility.Menu && {
                value: 'share',
                label: t('actionbar.share'),
                biData: BiData({
                    evid: 355,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    deviationid: deviation.deviationId
                }),
                onClick: showDesktopDeviationSharePopup
            },
            elementVisibilityMap.share === ElementVisibility.Menu && {
                value: 'shareToPost',
                label: t('actionbar.shareToPost'),
                onClick: restrictToVerifiedAndLoggedIn(ReferralType.SHARE_TO_POST, 'submitstatus', ()=>shareDeviationToPost(deviation)),
                biData: BiData({
                    evid: 356,
                    typeid: getDeviationResourceType(deviation),
                    itemid: deviation.deviationId,
                    social_share: 'da_post',
                    deviationid: deviation.deviationId
                })
            },
            elementVisibilityMap.report === ElementVisibility.Menu && {
                value: 'report',
                label: t('actionbar.report'),
                biData: BiData({
                    evid: 20,
                    modal_version: 2,
                    deviationid: deviation.deviationId
                }),
                onClick: ()=>{
                    showReportModal(deviation);
                    closeTooltip();
                }
            },
            elementVisibilityMap.linkNft === ElementVisibility.Menu && {
                value: 'linknft',
                label: t('actionbar.linkNft'),
                onClick: ()=>{
                    showNftLinkPopup(deviation);
                    closeTooltip();
                }
            }
        ]
    });
};
MoreMenuContent.displayName = 'MoreMenuContent';
export default MoreMenuContent;
